module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.galleryFS) ? _c('div', {
    staticClass: "fullscreen"
  }, [_c('div', {
    staticClass: "gallery-captions"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.galleryCaption.caption)
    }
  }), _c('p', [_vm._v(_vm._s(_vm.galleryCaption.credit))])]), _c('swiper', {
    ref: "fullscreen-gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.gallery), function(image) {
    return (!_vm.loading) ? _c('swiper-slide', {
      key: image.title
    }, [_c('visual', {
      attrs: {
        "image": image.url
      }
    })], 1) : _vm._e()
  })), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }), _c('div', {
    staticClass: "index"
  }, [_c('p', [_vm._v(_vm._s(_vm.galleryIndex) + " of " + _vm._s(_vm.numGalleryItems))])]), _c('div', {
    staticClass: "less",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg"
    }
  })], 1)], 1) : _vm._e()]), _c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading && !_vm.galleryFS) ? _c('div', {
    staticClass: "content exhibition"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions'
      }
    }
  }, [_c('h2', [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.status))]), _c('div', {
    staticClass: "title-details"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "teaser"
  }, [_vm._v(_vm._s(_vm.teaser))]), _c('h4', [_vm._v(_vm._s(_vm.date))]), (_vm.curator) ? _c('h4', {
    staticClass: "curator"
  }, [_vm._v("curated by: " + _vm._s(_vm.curator))]) : _vm._e(), _c('h4', {
    staticClass: "share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share")]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12"
  }, [(_vm.hero) ? _c('visual', {
    attrs: {
      "image": _vm.hero.url,
      "background": "cover",
      "role": "img",
      "aria-label": _vm.captions
    }
  }) : _vm._e(), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "title-details-mobile"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "teaser"
  }, [_vm._v(_vm._s(_vm.teaser))]), _c('h4', [_vm._v(_vm._s(_vm.date))])]), _c('div', {
    staticClass: "copy wysiwyg",
    class: {
      noimage: !_vm.hero.url
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })], 1), (_vm.gallery.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 preview"
  }, [_c('h2', [_vm._v("exhibition preview")])]) : _vm._e(), (_vm.gallery.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 preview"
  }, [_c('div', {
    staticClass: "more"
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/plus_black.svg"
    }
  })], 1)]), _c('swiper', {
    ref: "gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('visual', {
      attrs: {
        "image": image.url,
        "alt": image.meta.caption
      }
    })], 1)
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2), _c('div', {
    staticClass: "index"
  }, [_c('p', [_vm._v(_vm._s(_vm.galleryIndex) + " of " + _vm._s(_vm.numGalleryItems))])])], 1) : _vm._e(), (_vm.relatedPrograms.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 programs"
  }, [_c('h2', [_vm._v("related programs")])]) : _vm._e(), (_vm.relatedPrograms.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 programs details"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedPrograms), function(program) {
    return _c('div', {
      staticClass: "col-5",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: 'current',
            id: program.uid
          }
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(program.title))]), _c('h4', [_vm._v(_vm._s(program.content.date))]), _c('p', [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1)
  }))]) : _vm._e(), (_vm.press.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 press"
  }, [_c('h2', [_vm._v("in the news")])]) : _vm._e(), (_vm.press.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 press"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.press), function(article) {
    return _c('div', {
      staticClass: "col-5",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('a', {
      attrs: {
        "href": article.link,
        "target": "_blank"
      }
    }, [_c('h3', [_vm._v(_vm._s(article.teaser))]), _c('h4', [_vm._v(_vm._s(_vm.articleDate(article.date)))]), _c('p', [_vm._v("- " + _vm._s(article.publication))])])])
  }))]) : _vm._e(), (_vm.resources.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 resources"
  }, [_c('h2', [_vm._v("resources")])]) : _vm._e(), (_vm.resources.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 resources"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.resources), function(resource) {
    return _c('div', {
      staticClass: "col-5_xs-12",
      attrs: {
        "data-push-right": "off-1_xs-0"
      }
    }, [_c('a', {
      attrs: {
        "href": resource.link,
        "target": "_blank"
      }
    }, [_c('h3', [_vm._v(_vm._s(resource.title))])])])
  }))]) : _vm._e()])]) : _vm._e()]), (!_vm.galleryFS) ? _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0312f434"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exhibition.vue
// module id = 211
// module chunks = 1